import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog";
import { Skeleton } from "src/@/components/ui/skeleton";
import { Input } from "src/@/components/ui/input";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from "src/@/components/ui/table";
import MenuDatas2 from "src/components/MenuDatas2";
import { validaLabelMenuDatas } from "src/utils/functions";
import Iconify from "src/components/Iconify";
import { Badge } from "src/@/components/ui/badge";
import Scrollbar from "src/components/Scrollbar";
import { getFriendlyName } from "src/utils/automacoes.utils";
import { fDateTime } from "src/utils/formatTime";

//action
import v2_actionLogsAutomacoes from "src/actions/v2/automacoes/v2_actionLogsAutomacoes";

//utils
import moment from "moment";

export function DialogLogsAutomacao({ user, automationId }) {
  const { enqueueSnackbar } = useSnackbar();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuDatas, setOpenMenuDatas] = useState(false);
  const [inicio, setInicio] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [periodo, setPeriodo] = useState("mes_atual");
  const [openModal, setOpenModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const inicio2 = moment(inicio).format("YYYY-MM-DD");
  const final2 = moment(final).format("YYYY-MM-DD");

  async function getLogs(automacaoId, inicio, final, periodo) {
    setLoading(true);
    try {
      let querys = `?inicio=${inicio}&final=${final}&periodo=${periodo}`;
      if (automacaoId) {
        querys += `&automation_id=${automacaoId}`;
      }
      const response = await v2_actionLogsAutomacoes(user.clienteId, querys);
      setLogs(response.data.data);
      setFilteredLogs(response.data.data); // Inicializa a lista filtrada
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Erro ao carregar logs de automação", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };


  const onFiltrar = async (automacaoId, value) => {
    console.log(value);
    setPeriodo(value)
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    let querys = `?periodo=${value}&inicio=${inicio2}&final=${final2}`;
    if (automacaoId) {
      querys += `&automation_id=${automacaoId}`;
    }
    await getLogs(automationId, inicio2, final2, value);
  }

  useEffect(() => {
    console.log('rodou aqui')
    getLogs(automationId, inicio2, final2, periodo);
  }, [openModal]);

  useEffect(() => {
    const filtered = logs.filter((log) =>
      log.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredLogs(filtered);
  }, [searchText, logs]);

  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogTrigger asChild>
        <Button variant="outline">Logs de Automação</Button>
      </DialogTrigger>
      <DialogContent className="max-w-7xl min-w-[900px] max-h-[600px]">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <div>Logs de automação</div>
          </DialogTitle>
        </DialogHeader>

        {/* Filtros */}
        <div className="flex items-center gap-4 my-4 justify-between">
          <div className="w-1/3 flex flex-row items-center gap-2">
            <div className="w-full">
              <Input
                id="search"
                placeholder="Pesquisar"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div>
              <MenuDatas2
                anchorEl={anchorEl}
                open={openMenuDatas}
                onClose={() => setAnchorEl(false)}
                inicial={inicio}
                final={final}
                content={validaLabelMenuDatas(periodo, inicio, final)}
                changeInicial={(newValue) => setInicio(newValue)}
                changeFinal={(newValue) => {
                  setFinal(newValue);
                }}
                onSelect={(value) => {
                  setPeriodo(value);
                  setAnchorEl(null);
                  onFiltrar(automationId, value);
                }}
                onPesquisar={() => { }}
              />
            </div>
          </div>

          <Button variant="secondary" className="mt-4" onClick={() => getLogs(automationId, inicio2, final2, periodo)}>
            <Iconify icon="solar:refresh-bold" className="mr-2" />
            Atualizar logs
          </Button>
        </div>

        <Scrollbar className="h-[400px] min-w-[400px]">
          {/* Tabela de Logs */}
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Automação</TableHead>
                <TableHead>Ação</TableHead>
                <TableHead>Execução</TableHead>
                <TableHead>Telefone</TableHead>
                <TableHead>Data</TableHead>
                <TableHead>Executado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading ? (
                Array.from({ length: 5 }).map((_, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Skeleton className="h-4 w-[150px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[200px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[100px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[100px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[120px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[100px]" />
                    </TableCell>
                    <TableCell>
                      <Skeleton className="h-4 w-[50px]" />
                    </TableCell>
                  </TableRow>
                ))
              ) : filteredLogs.length > 0 ? (
                filteredLogs.map((log) => (
                  <TableRow key={log._id}>
                    <TableCell className="w-[200px]">{log._id}</TableCell>
                    <TableCell>
                      {log.name.substr(0, 30)}
                      {log.name.length > 30 && "..."}
                    </TableCell>
                    <TableCell>{getFriendlyName(log?.scope?.params?.from?.action)}</TableCell>
                    <TableCell>
                      {log?.scope?.response?.actionExecute && getFriendlyName(log?.scope?.response?.actionExecute)}
                    </TableCell>
                    <TableCell>{log.scope?.response?.numero}</TableCell>
                    <TableCell className="w-[150px]">{fDateTime(log.date)}</TableCell>
                    <TableCell className="w-[50px]">
                      {log?.scope?.execute ? (
                        <Badge className="bg-green-400">Sim</Badge>
                      ) : (
                        <Badge className="bg-red-400">Não</Badge>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="7" className="text-center py-4 text-gray-500">
                    Você ainda não executou nenhuma automação. Comece a automatizar e volte aqui
                    para ver o log de atividades de sua automação.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Scrollbar>
      </DialogContent>
    </Dialog>
  );
}
